export default "__VITE_ASSET__DFJjPDZr__"